import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/industry',
  component: Layout,
  redirect: '/industry/index',
  name: 'Industry',
  meta: {
    title: '行业管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'IndustryIndex',
      component: () => import('@/views/industry/index.vue'),
      meta: {
        title: '行业管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/industry"
      },
    }
  ],
}

export default routes
